/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Specialists_All_ShortInputs */

const en_portal_specialists_all_short = /** @type {(inputs: Portal_Specialists_All_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const pl_portal_specialists_all_short = /** @type {(inputs: Portal_Specialists_All_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszyscy`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Portal_Specialists_All_ShortInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_specialists_all_short = /** @type {((inputs?: Portal_Specialists_All_ShortInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Specialists_All_ShortInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_specialists_all_short(inputs)
	return en_portal_specialists_all_short(inputs)
});